import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  onClick?: () => void;
}
export function Card({
  children,
  className = '',
  hover = true,
  onClick
}: CardProps) {
  return <div className={`bg-white rounded-lg border border-gray-100 shadow-sm overflow-hidden ${hover ? 'transition-shadow duration-300 hover:shadow-lg' : ''} ${onClick ? 'cursor-pointer' : ''} ${className}`} onClick={onClick} data-id="element-400">
      {children}
    </div>;
}